import { eventsDuck } from '@eb/redux-destination';

export const loggedOutSaveRedirect = (eventId: string) => {
    eventsDuck.api.loggedOutSaveRedirect(eventId, {
        pathname: window.location.pathname,
    });
};

export const parseFollowSignal = (organizerFollowCount: number) => {
    if (organizerFollowCount >= 10) {
        return {
            signal: { type: 'follow', value: organizerFollowCount },
        };
    }

    return {};
};
